import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type ClientService, ClientName } from '../client-service';

@injectable()
export class ClientServiceImpl implements ClientService {
    private _clientName = import.meta.env.VITE_PASSPORT_CLIENT_NAME as ClientName;

    public get clientName(): ClientName {
        return this._clientName;
    }

    public get isEureka(): boolean {
        return this._clientName === ClientName.EUREKA;
    }
}
